import { PrinterPosSyncIcon } from './PrinterPosSyncIcon';

/**
 * author: Colton Wiscombe
 * id E8726305-549E-45BE-9E41-D624A57B5D6A
 * name printer-pos-sync
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-sync.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleSyncIcon = PrinterPosSyncIcon;
export default PrinterPointOfSaleSyncIcon